import type { HTMLAttributes } from 'react';
import { cx } from './cx.js';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cx(
        'rounded-xl border border-slate-200 bg-white shadow-sm transition-shadow',
        className,
      )}
      {...props}
    />
  );
}
